var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-2",attrs:{"color":"primary","disabled":_vm.disabled},on:{"click":_vm.table2xls}},[_c('v-icon',[_vm._v("el-icon-document")]),(_vm.$vuetify.breakpoint.smAndUp)?_c('btn-title',[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }